(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const grid = document.querySelector('[data-most-loved-grid]');
    const source = document.querySelector('[data-most-loved-source]');

    if (!grid || !source) {
      return;
    }

    let products = [];

    try {
      products = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(products) || products.length === 0) {
      return;
    }

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[character]);

    const seededRandom = (seed) => {
      let state = seed >>> 0;

      return () => {
        state += 0x6D2B79F5;
        let value = state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
      };
    };

    const shuffle = (items, random) => {
      const shuffled = [...items];

      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(random() * (index + 1));
        [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
      }

      return shuffled;
    };

    const formatInr = (price) => {
      const amount = Number(price) / 100;

      return `Rs. ${new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      }).format(amount)}`;
    };

    const wireHoverVideos = (root) => {
      root.querySelectorAll('.product-card').forEach((card) => {
        const video = card.querySelector('.product-card__hover-video');
        if (!video) return;

        const play = () => {
          video.play()
            .then(() => { card.dataset.hoverVideoActive = 'true'; })
            .catch(() => { card.dataset.hoverVideoActive = 'false'; });
        };
        const stop = () => {
          card.dataset.hoverVideoActive = 'false';
          video.pause();
          video.currentTime = 0;
        };

        card.addEventListener('mouseenter', play);
        card.addEventListener('mouseleave', stop);
        card.addEventListener('focusin', play);
        card.addEventListener('focusout', stop);
      });
    };

    const rotationSlot = Math.floor(Date.now() / 259200000);
    const random = seededRandom(rotationSlot);
    const candidatePool = shuffle(products, random).slice(0, 24);
    const featuredProducts = shuffle(candidatePool, random).slice(0, 8);
    const badge = grid.dataset.mostLovedBadge || '';

    grid.innerHTML = featuredProducts.map((product) => {
      const title = escapeHtml(product.title);
      const image = product.image
        ? `<img src="${escapeHtml(product.image)}" loading="lazy" alt="${title}">`
        : '<div class="product-card__placeholder gem-placeholder"></div>';
      const hoverVideo = product.hoverVideo
        ? `<video class="product-card__hover-video" muted loop playsinline preload="metadata" aria-hidden="true"><source src="${escapeHtml(product.hoverVideo)}" type="video/mp4"></video>`
        : '';
      const hoverImage = !product.hoverVideo && product.hoverImage
        ? `<img class="product-card__hover-image" src="${escapeHtml(product.hoverImage)}" loading="lazy" alt="${title}">`
        : '';
      const price = formatInr(product.price);
      const compareAtPrice = Number(product.compareAtPrice || 0);
      const priceMarkup = compareAtPrice > Number(product.price)
        ? `<span class="product-card__price--sale">${price}</span><span class="product-card__price--compare">${formatInr(compareAtPrice)}</span>`
        : price;

      return `<a class="product-card" href="${escapeHtml(product.url)}"><div class="product-card__media">${image}${hoverVideo}${hoverImage}<div class="product-card__badge">${escapeHtml(badge)}</div></div><div class="product-card__info"><h3 class="product-card__title">${title}</h3><p class="product-card__price">${priceMarkup}</p></div></a>`;
    }).join('');

    wireHoverVideos(grid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartItems = Array.from(document.querySelectorAll('[data-cart-item]'));
  const cartSummaryTotal = document.querySelector('[data-cart-summary-total]');
  const cartDeliveryTotal = Number(cartSummaryTotal?.dataset.cartDeliveryTotal || 0);
  const cartSummaryNetSubtotal = document.querySelector('[data-cart-summary-net-subtotal]');
  const cartSummaryTaxOutputs = {
    gemstone: document.querySelector('[data-cart-summary-gemstone-tax]'),
    silver: document.querySelector('[data-cart-summary-silver-tax]'),
    silver_gemstone: document.querySelector('[data-cart-summary-silver-gemstone-tax]'),
    coral: document.querySelector('[data-cart-summary-coral-tax]')
  };
  const cartSummaryTaxRows = {
    gemstone: document.querySelector('[data-cart-tax-row="gemstone"]'),
    silver: document.querySelector('[data-cart-tax-row="silver"]'),
    silver_gemstone: document.querySelector('[data-cart-tax-row="silver_gemstone"]'),
    coral: document.querySelector('[data-cart-tax-row="coral"]')
  };

  const formatInr = (price) => {
    const amount = Number(price || 0) / 100;
    const formatted = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    return `Rs. ${formatted}`;
  };

  const getBulkDiscountPercent = (quantity) => {
    if (quantity >= 20) {
      return 60;
    }

    if (quantity >= 10) {
      return 55;
    }

    if (quantity >= 5) {
      return 45;
    }

    return 0;
  };

  const isStatementItem = (item) => item.dataset.statementPiece === 'true';

  const getCartQuantity = (item, value) => {
    const quantity = Math.max(0, Number(value || 0));
    return isStatementItem(item) && quantity > 0 ? 1 : quantity;
  };

  const getBraceletQuantityTotal = () => {
    return cartItems.reduce((total, item) => {
      const price = item.querySelector('[data-cart-line-price]');
      const input = item.querySelector('.cart-item__qty-input');

      if (!price || price.dataset.bulkBracelet !== 'true' || !input) {
        return total;
      }

      return total + getCartQuantity(item, input.value || 0);
    }, 0);
  };

  const normalizeBulkLabel = (value) => {
    return String(value || '')
      .toLowerCase()
      .replace(/[()]/g, ' ')
      .replace(/grams?/g, 'g')
      .replace(/grms?/g, 'g')
      .replace(/\s*-\s*/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const parseExactBulkOffers = (description) => {
    const normalized = String(description || '').replace(/\s+/g, ' ').trim();
    const offers = [];
    const labeledBulkPattern = /\(?\s*([^()\n\r]*?)\s*Bulk\s+(\d+)\s+pieces?\s*\)?\s*[:\-]?\s*(?:Rs\.?\s*)?([\d,]+(?:\.\d+)?)\s*rs?/gi;
    const packPattern = /Pack\s+of\s+(\d+)\s+pieces?.*?Rs\.?\s*([\d,]+(?:\.\d+)?)/gi;
    let match = labeledBulkPattern.exec(normalized);

    while (match) {
      const label = String(match[1] || '').replace(/[:\-]+$/g, '').trim();
      offers.push({
        label,
        normalizedLabel: normalizeBulkLabel(label),
        quantity: Number(match[2]),
        price: Number(String(match[3]).replace(/,/g, '')) * 100,
      });
      match = labeledBulkPattern.exec(normalized);
    }

    match = packPattern.exec(normalized);

    while (match) {
      offers.push({
        label: '',
        normalizedLabel: '',
        quantity: Number(match[1]),
        price: Number(String(match[2]).replace(/,/g, '')) * 100,
      });
      match = packPattern.exec(normalized);
    }

    return offers;
  };

  const findExactBulkOffer = (description, variantTitle) => {
    const offers = parseExactBulkOffers(description);

    if (offers.length === 0) {
      return null;
    }

    const normalizedVariantTitle = normalizeBulkLabel(variantTitle);
    const matchedOffer = offers.find((offer) => {
      if (!offer.normalizedLabel) {
        return false;
      }

      return normalizedVariantTitle.includes(offer.normalizedLabel)
        || offer.normalizedLabel.includes(normalizedVariantTitle);
    });

    if (matchedOffer) {
      return matchedOffer;
    }

    return offers.find((offer) => !offer.normalizedLabel) || offers[0];
  };

  const getExactBulkLinePrice = (quantity, unitPrice, offer) => {
    if (!offer || !offer.quantity || quantity < offer.quantity) {
      return null;
    }

    const bundleCount = Math.floor(quantity / offer.quantity);
    const remainder = quantity % offer.quantity;

    return (bundleCount * offer.price) + (remainder * unitPrice);
  };

  const getInclusiveTaxSplit = (inclusivePrice, taxRateBps) => {
    const taxDenominator = 10000 + Number(taxRateBps || 0);
    const taxAmount = taxDenominator > 10000
      ? Math.round(Number(inclusivePrice || 0) * Number(taxRateBps || 0) / taxDenominator)
      : 0;

    return {
      netPrice: Number(inclusivePrice || 0) - taxAmount,
      taxAmount
    };
  };

  const recalculateCartPrices = () => {
    const braceletQuantityTotal = getBraceletQuantityTotal();
    const discountPercent = getBulkDiscountPercent(braceletQuantityTotal);
    let cartTotal = 0;
    let netSubtotal = 0;
    const taxTotals = {
      gemstone: 0,
      silver: 0,
      silver_gemstone: 0,
      coral: 0
    };

    cartItems.forEach((item) => {
      const price = item.querySelector('[data-cart-line-price]');
      const input = item.querySelector('.cart-item__qty-input');
      const currentLinePrice = item.querySelector('[data-cart-current-line-price]');
      const compareLinePrice = item.querySelector('[data-cart-compare-line-price]');
      const bulkNote = item.querySelector('[data-cart-bulk-note]');

      if (!price || !input || !currentLinePrice) {
        return;
      }

      const quantity = getCartQuantity(item, input.value || 0);

      if (String(input.value) !== String(quantity)) {
        input.value = quantity;
      }

      const unitPrice = Number(price.dataset.unitPrice || 0);
      const originalLinePrice = unitPrice * quantity;
      const exactBulkOffer = findExactBulkOffer(price.dataset.bulkDescription, price.dataset.bulkVariantTitle);
      const exactBulkLinePrice = getExactBulkLinePrice(quantity, unitPrice, exactBulkOffer);
      const isBulkBracelet = price.dataset.bulkBracelet === 'true';
      const lineDiscountPercent = exactBulkLinePrice === null && isBulkBracelet ? discountPercent : 0;
      const lineDisplayPrice = exactBulkLinePrice === null
        ? Math.round(originalLinePrice * (100 - lineDiscountPercent) / 100)
        : exactBulkLinePrice;

      cartTotal += lineDisplayPrice;
      const taxClass = item.dataset.taxClass;
      const taxSplit = getInclusiveTaxSplit(lineDisplayPrice, item.dataset.taxRateBps);
      netSubtotal += taxSplit.netPrice;

      if (Object.prototype.hasOwnProperty.call(taxTotals, taxClass)) {
        taxTotals[taxClass] += taxSplit.taxAmount;
      }

      currentLinePrice.textContent = formatInr(lineDisplayPrice);

      if (compareLinePrice) {
        const hasBulkPrice = exactBulkLinePrice !== null || lineDiscountPercent > 0;
        compareLinePrice.textContent = hasBulkPrice ? formatInr(originalLinePrice) : '';
        compareLinePrice.hidden = !hasBulkPrice;
      }

      if (bulkNote) {
        const suffix = price.dataset.bulkNoteSuffix || '';
        if (exactBulkLinePrice !== null && exactBulkOffer) {
          const bundleCount = Math.floor(quantity / exactBulkOffer.quantity);
          const bundleLabel = bundleCount > 1 ? `${bundleCount} bulk packs applied` : 'bulk price applied';
          bulkNote.textContent = `${bundleLabel}: ${exactBulkOffer.quantity} pieces for ${formatInr(exactBulkOffer.price)}`;
          bulkNote.hidden = false;
        } else {
          bulkNote.textContent = lineDiscountPercent > 0 ? `${lineDiscountPercent}% ${suffix}` : '';
          bulkNote.hidden = lineDiscountPercent === 0;
        }
      }
    });

    if (cartSummaryNetSubtotal) {
      cartSummaryNetSubtotal.textContent = formatInr(netSubtotal);
    }

    Object.keys(taxTotals).forEach((taxClass) => {
      const output = cartSummaryTaxOutputs[taxClass];
      const row = cartSummaryTaxRows[taxClass];
      const amount = taxTotals[taxClass];

      if (output) {
        output.textContent = formatInr(amount);
      }

      if (row) {
        row.hidden = amount <= 0;
      }
    });

    if (cartSummaryTotal) {
      cartSummaryTotal.textContent = formatInr(cartTotal + cartDeliveryTotal);
    }
  };

  const syncCartLine = (item, immediate = false) => {
    const input = item.querySelector('.cart-item__qty-input');

    if (!input || !item.dataset.lineKey) {
      return;
    }

    const quantity = getCartQuantity(item, input.value || 0);
    input.value = quantity;

    window.clearTimeout(item.cartSyncTimer);
    item.cartSyncTimer = window.setTimeout(async () => {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.dataset.lineKey,
            quantity
          })
        });

        if (quantity === 0) {
          window.location.reload();
        }
      } catch (error) {
        window.location.reload();
      }
    }, immediate ? 0 : 350);
  };

  cartItems.forEach((item) => {
    const input = item.querySelector('.cart-item__qty-input');
    const minusButton = item.querySelector('[data-cart-qty-minus]');
    const plusButton = item.querySelector('[data-cart-qty-plus]');

    if (!input) {
      return;
    }

    if (isStatementItem(item)) {
      input.max = '1';
      input.readOnly = true;

      if (minusButton) {
        minusButton.disabled = false;
        minusButton.removeAttribute('aria-disabled');
      }

      if (plusButton) {
        plusButton.disabled = true;
        plusButton.setAttribute('aria-disabled', 'true');
      }

      if (Number(item.dataset.cartCurrentQuantity || input.value || 0) > 1) {
        input.value = 1;
        syncCartLine(item, true);
      }
    }

    if (minusButton) {
      minusButton.addEventListener('click', () => {
        input.value = getCartQuantity(item, Number(input.value || 0) - 1);
        recalculateCartPrices();
        syncCartLine(item);
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', () => {
        input.value = getCartQuantity(item, Number(input.value || 0) + 1);
        recalculateCartPrices();
        syncCartLine(item);
      });
    }

    input.addEventListener('input', () => {
      input.value = getCartQuantity(item, input.value || 0);

      recalculateCartPrices();
      syncCartLine(item);
    });
  });

  recalculateCartPrices();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const wireHoverVideos = (root) => {
      root.querySelectorAll('.pc').forEach((card) => {
        if (card.dataset.hoverVideoWired === 'true') return;

        const video = card.querySelector('.pc__hover-video');
        if (!video) return;

        card.dataset.hoverVideoWired = 'true';
        const play = () => {
          video.play()
            .then(() => { card.dataset.hoverVideoActive = 'true'; })
            .catch(() => { card.dataset.hoverVideoActive = 'false'; });
        };
        const stop = () => {
          card.dataset.hoverVideoActive = 'false';
          video.pause();
          video.currentTime = 0;
        };

        card.addEventListener('mouseenter', play);
        card.addEventListener('mouseleave', stop);
        card.addEventListener('focusin', play);
        card.addEventListener('focusout', stop);
      });
    };
    const grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;
    const pagination = document.querySelector('[data-collection-pagination]');
    const sortControl = document.querySelector('[data-collection-sort]');
    const status = document.querySelector('[data-collection-load-status]');
    const message = status.querySelector('[data-collection-load-message]');
    const retry = status.querySelector('[data-collection-retry]');
    const loadingMessage = message.textContent;
    const sourceUrl = new URL(window.location.href);
    const sourcePageCount = Number(grid.dataset.collectionPageCount) || 1;
    const sourcePage = Number(grid.dataset.collectionPage) || 1;
    const expectedCount = Number(grid.dataset.collectionProductCount);
    const cardsPerPage = Number(grid.dataset.productsPerPage) || 12;
    const currentCards = Array.from(grid.querySelectorAll('[data-collection-product-card]'));
    let products = null;

    const pageUrl = (page, sort) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort);
      if (page > 1) url.searchParams.set('page', String(page));
      else url.searchParams.delete('page');
      return url;
    };
    const selectedSort = () => new URL(window.location.href).searchParams.get('sort_by') || 'price-descending';
    const comparePrices = (first, second, sort) => {
      const difference = Number(first.dataset.price) - Number(second.dataset.price);
      // A stable tie-breaker gives the same page boundaries after reload.
      return (sort === 'price-ascending' ? difference : -difference) ||
        Number(first.dataset.productId) - Number(second.dataset.productId);
    };
    const showPage = (page, sort, historyMode) => {
      const ordered = [...products];
      if (sort === 'price-ascending' || sort === 'price-descending') {
        ordered.sort((a, b) => comparePrices(a, b, sort));
      }
      const pages = Math.max(Math.ceil(ordered.length / cardsPerPage), 1);
      const current = Math.min(Math.max(page, 1), pages);
      grid.querySelectorAll('.pc__hover-video').forEach(video => video.pause());
      if (ordered.length) {
        grid.replaceChildren(...ordered.slice((current - 1) * cardsPerPage, current * cardsPerPage));
      }
      pagination.replaceChildren();
      if (pages > 1) {
        for (let number = 1; number <= pages; number += 1) {
          const link = document.createElement('a');
          link.href = pageUrl(number, sort).toString();
          link.textContent = String(number);
          if (number === current) link.setAttribute('aria-current', 'page');
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            showPage(number, selectedSort(), 'pushState');
            window.scrollTo(0, 0);
          });
          pagination.append(link);
        }
      }
      if (sortControl) {
        sortControl.querySelectorAll('[data-collection-sort-option]').forEach(option => {
          const selected = option.dataset.collectionSortOption === sort;
          option.setAttribute('aria-selected', String(selected));
          if (selected) sortControl.querySelector('.coll-sort__trigger span').textContent = option.querySelector('span').textContent;
        });
      }
      if (historyMode) window.history[historyMode]({}, '', pageUrl(current, sort));
      grid.hidden = false;
      grid.removeAttribute('aria-busy');
      pagination.hidden = false;
      status.hidden = true;
      wireHoverVideos(grid);
    };

    if (sortControl) {
      sortControl.querySelectorAll('[data-collection-sort-option]').forEach(option => {
        option.addEventListener('click', () => {
          const sort = option.dataset.collectionSortOption;
          sortControl.querySelector('.coll-sort__menu').open = false;
          if (products) showPage(1, sort, 'pushState');
          else window.location.assign(pageUrl(1, sort).toString());
        });
      });
    }

    const fetchPage = async page => {
      if (page === sourcePage) return currentCards;
      const url = new URL(sourceUrl);
      url.searchParams.set('page', String(page));
      url.searchParams.set('sections', grid.dataset.sectionId);
      for (let attempt = 0; attempt < 3; attempt += 1) {
        try {
          const response = await fetch(url.toString(), { signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw new Error('Collection page request failed');
          const sections = await response.json();
          const html = sections[grid.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Collection section missing');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const pageGrid = doc.querySelector('[data-collection-grid]');
          if (!pageGrid || Number(pageGrid.dataset.collectionPage) !== page ||
              Number(pageGrid.dataset.collectionPageCount) !== sourcePageCount ||
              Number(pageGrid.dataset.collectionProductCount) !== expectedCount) {
            throw new Error('Collection changed while loading');
          }
          return Array.from(pageGrid.querySelectorAll('[data-collection-product-card]'));
        } catch (error) {
          if (attempt === 2) throw error;
          await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
        }
      }
    };
    const loadCollection = async () => {
      grid.hidden = true;
      grid.setAttribute('aria-busy', 'true');
      pagination.hidden = true;
      status.hidden = false;
      retry.hidden = true;
      message.textContent = loadingMessage;
      try {
        const results = new Array(sourcePageCount);
        let nextPage = 1;
        // Bound concurrency and fetch only the collection section, not entire pages.
        const worker = async () => {
          while (nextPage <= sourcePageCount) {
            const page = nextPage++;
            results[page - 1] = await fetchPage(page);
          }
        };
        await Promise.all(Array.from({ length: Math.min(3, sourcePageCount) }, worker));
        const all = results.flat();
        if (all.length !== expectedCount ||
            new Set(all.map(card => card.dataset.productId)).size !== expectedCount) {
          throw new Error('Incomplete collection');
        }
        products = all;
        const url = new URL(window.location.href);
        showPage(Number(url.searchParams.get('page')) || 1, selectedSort(), 'replaceState');
      } catch (error) {
        // Never silently show a partially sorted collection on a network failure.
        message.textContent = message.dataset.errorMessage;
        retry.hidden = false;
        grid.removeAttribute('aria-busy');
      }
    };
    retry.addEventListener('click', loadCollection);
    window.addEventListener('popstate', () => {
      if (products) showPage(Number(new URL(window.location.href).searchParams.get('page')) || 1, selectedSort());
    });
    loadCollection();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstone-certificate-sample"] && !Shopify.designMode) return;
  try {
    
  const certificateSections = document.querySelectorAll('.certificate-sample');

  certificateSections.forEach((section) => {
    const modal = section.querySelector('[data-certificate-modal]');
    const modalImage = section.querySelector('[data-certificate-modal-image]');
    const triggers = section.querySelectorAll('[data-certificate-zoom-src]');
    const closeButtons = section.querySelectorAll('[data-certificate-close]');
    let lastTrigger = null;

    if (!modal || !modalImage) return;

    document.body.appendChild(modal);

    const closeModal = () => {
      modal.hidden = true;
      modalImage.removeAttribute('src');
      modalImage.alt = '';
      document.documentElement.classList.remove('certificate-sample-modal-open');

      if (lastTrigger) {
        lastTrigger.focus();
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        lastTrigger = trigger;
        modalImage.src = trigger.dataset.certificateZoomSrc;
        modalImage.alt = trigger.dataset.certificateZoomAlt || '';
        modal.hidden = false;
        document.documentElement.classList.add('certificate-sample-modal-open');
        modal.querySelector('[data-certificate-close]')?.focus();
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.header-float');
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const searchToggle = document.querySelector('.header__search-toggle');
  const searchForm = document.querySelector('.header__search-form');
  const searchInput = document.querySelector('.header__search-input');
  const searchSuggestions = document.querySelector('[data-search-suggestions]');
  const heroHeight = () => window.innerHeight * 0.5;
  let searchController = null;
  let searchDebounce = null;

  function updateHeader() {
    if (!header) {
      return;
    }

    header.classList.toggle('is-scrolled', window.scrollY > heroHeight());

    header.classList.remove('is-mobile-nav-hidden');
  }

  const dropdownWraps = document.querySelectorAll('.header__dropdown-wrap');
  const crystalDropdown = document.querySelector('.header__dropdown--crystals');
  crystalDropdown?.style.setProperty('--crystal-menu-rows', Math.ceil(crystalDropdown.children.length / 4));

  const fitDropdowns = () => {
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    const viewportLeft = viewport ? viewport.offsetLeft : 0;
    const viewportRight = viewportLeft + (viewport ? viewport.width : window.innerWidth);

    dropdownWraps.forEach((wrap) => {
      const panel = wrap.querySelector('.header__dropdown');
      if (!panel) return;
      panel.style.marginLeft = '';
      panel.style.removeProperty('--header-dropdown-height');
      if (window.innerWidth <= 1024 || !wrap.classList.contains('is-open')) return;

      const bounds = panel.getBoundingClientRect();
      panel.style.setProperty('--header-dropdown-height', `${Math.max(0, Math.floor(viewportBottom - bounds.top - 16))}px`);
      const shift = Math.max(viewportLeft + 16 - bounds.left, Math.min(0, viewportRight - 16 - bounds.right));
      panel.style.marginLeft = `${shift}px`;
    });
  };
  const silverCategory = document.querySelector('.header__category-silver');
  const silverCategoryToggle = document.querySelector('.header__category-silver-toggle');
  const silverCategorySubmenu = document.querySelector('#header-silver-category-dropdown');
  const silverCategoryDropdown = silverCategory?.closest('.header__dropdown-wrap');
  const madeToOrderCategory = document.querySelector('.header__category-made-to-order');
  const madeToOrderCategoryToggle = document.querySelector('.header__category-made-to-order-toggle');
  const madeToOrderCategorySubmenu = document.querySelector('#header-made-to-order-category-dropdown');
  const madeToOrderCategoryDropdown = madeToOrderCategory?.closest('.header__dropdown-wrap');
  const chakraMenu = document.querySelector('.header__meaning-chakra');
  const chakraMenuToggle = document.querySelector('.header__meaning-chakra-toggle');
  const chakraMenuSubmenu = document.querySelector('#header-chakra-dropdown');
  const chakraMenuDropdown = chakraMenu?.closest('.header__dropdown-wrap');
  const forestCarvingsMenu = document.querySelector('.header__forest-carvings');
  const forestCarvingsToggle = document.querySelector('.header__forest-carvings-toggle');
  const forestCarvingsSubmenu = document.querySelector('#header-forest-carvings-dropdown');
  const forestCarvingsDropdown = forestCarvingsMenu?.closest('.header__dropdown-wrap');

  const toggleSilverCategory = (shouldOpen) => {
    if (!silverCategory || !silverCategoryToggle || !silverCategorySubmenu) {
      return;
    }

    silverCategory.classList.toggle('is-open', shouldOpen);
    silverCategorySubmenu.hidden = !shouldOpen;
    silverCategoryToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    silverCategoryToggle.setAttribute(
      'aria-label',
      shouldOpen ? silverCategoryToggle.dataset.closeLabel : silverCategoryToggle.dataset.openLabel
    );
  };

  const toggleMadeToOrderCategory = (shouldOpen) => {
    if (!madeToOrderCategory || !madeToOrderCategoryToggle || !madeToOrderCategorySubmenu) {
      return;
    }

    madeToOrderCategory.classList.toggle('is-open', shouldOpen);
    madeToOrderCategorySubmenu.hidden = !shouldOpen;
    madeToOrderCategoryToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    madeToOrderCategoryToggle.setAttribute(
      'aria-label',
      shouldOpen ? madeToOrderCategoryToggle.dataset.closeLabel : madeToOrderCategoryToggle.dataset.openLabel
    );
  };

  const toggleChakraMenu = (shouldOpen) => {
    if (!chakraMenu || !chakraMenuToggle || !chakraMenuSubmenu) {
      return;
    }

    chakraMenu.classList.toggle('is-open', shouldOpen);
    chakraMenuSubmenu.hidden = !shouldOpen;
    chakraMenuToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    chakraMenuToggle.setAttribute(
      'aria-label',
      shouldOpen ? chakraMenuToggle.dataset.closeLabel : chakraMenuToggle.dataset.openLabel
    );
  };

  const toggleForestCarvingsMenu = (shouldOpen) => {
    if (!forestCarvingsMenu || !forestCarvingsToggle || !forestCarvingsSubmenu) {
      return;
    }

    forestCarvingsMenu.classList.toggle('is-open', shouldOpen);
    forestCarvingsSubmenu.hidden = !shouldOpen;
    forestCarvingsToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    forestCarvingsToggle.setAttribute(
      'aria-label',
      shouldOpen ? forestCarvingsToggle.dataset.closeLabel : forestCarvingsToggle.dataset.openLabel
    );
  };

  if (silverCategoryToggle) {
    silverCategoryToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleSilverCategory(!silverCategory.classList.contains('is-open'));
    });
  }

  if (madeToOrderCategoryToggle) {
    madeToOrderCategoryToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleMadeToOrderCategory(!madeToOrderCategory.classList.contains('is-open'));
    });
  }

  if (chakraMenuToggle) {
    chakraMenuToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleChakraMenu(!chakraMenu.classList.contains('is-open'));
    });
  }

  if (forestCarvingsToggle) {
    forestCarvingsToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleForestCarvingsMenu(!forestCarvingsMenu.classList.contains('is-open'));
    });
  }

  const closeSearch = () => {
    if (!header || !searchToggle) {
      return;
    }

    header.classList.remove('is-search-open');
    searchToggle.setAttribute('aria-expanded', 'false');

    if (searchSuggestions) {
      searchSuggestions.hidden = true;
      searchSuggestions.innerHTML = '';
    }
  };

  if (searchToggle && header) {
    searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const shouldOpen = !header.classList.contains('is-search-open');
      header.classList.toggle('is-search-open', shouldOpen);
      searchToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

      if (shouldOpen) {
        toggleSilverCategory(false);
        toggleMadeToOrderCategory(false);
        toggleChakraMenu(false);
        toggleForestCarvingsMenu(false);
        dropdownWraps.forEach((wrap) => {
          wrap.classList.remove('is-open');
          wrap.querySelector('.header__dropdown-trigger')?.setAttribute('aria-expanded', 'false');
        });

        window.setTimeout(() => searchInput?.focus(), 0);
      }
    });
  }

  if (searchForm) {
    searchForm.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }

  const formatSuggestionPrice = (price) => {
    if (!price) {
      return '';
    }

    const numericPrice = Number(price.amount || price);

    if (!numericPrice) {
      return '';
    }

    if (typeof price === 'string') {
      return `Rs. ${numericPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    }

    if (price.amount) {
      return `Rs. ${numericPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    }

    return '';
  };

  const productTitleMatchesQuery = (title, query) => {
    const queryTerms = query
      .toLocaleLowerCase()
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    const productTitle = (title || '').toLocaleLowerCase();

    return queryTerms.length > 0 && queryTerms.every((term) => productTitle.includes(term));
  };

  const renderSearchSuggestions = (products) => {
    if (!searchSuggestions) {
      return;
    }

    if (!products.length) {
      searchSuggestions.innerHTML = '<p class="header__search-suggestion-empty">No products found</p>';
      searchSuggestions.hidden = false;
      return;
    }

    searchSuggestions.innerHTML = products.map((product) => {
      const image = product.image
        ? `<img src="${product.image}" alt="${product.title || 'Product'}" loading="lazy">`
        : '<span class="header__search-suggestion-placeholder" aria-hidden="true"></span>';
      const price = formatSuggestionPrice(product.price);

      return `
        <a class="header__search-suggestion" href="${product.url}">
          ${image}
          <span>
            <span class="header__search-suggestion-title">${product.title}</span>
            ${price ? `<span class="header__search-suggestion-price">${price}</span>` : ''}
          </span>
        </a>
      `;
    }).join('');
    searchSuggestions.hidden = false;
  };

  const fetchSearchSuggestions = (query) => {
    query = query.replace(/\b(?:ganets?|granets?|garnetts?)\b/gi, 'garnet');
    if (!searchSuggestions) {
      return;
    }

    if (searchController) {
      searchController.abort();
    }

    if (query.length < 2) {
      searchSuggestions.hidden = true;
      searchSuggestions.innerHTML = '';
      return;
    }

    searchController = new AbortController();
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '5',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor'
    });

    fetch(`${window.Shopify.routes.root}search/suggest.json?${params.toString()}`, {
      signal: searchController.signal
    })
      .then((response) => response.json())
      .then((data) => {
        const products = (data?.resources?.results?.products || []).filter((product) =>
          productTitleMatchesQuery(product.title, query)
        );
        renderSearchSuggestions(products);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          searchSuggestions.hidden = true;
        }
      });
  };

  if (searchInput) {
    searchInput.addEventListener('input', (event) => {
      window.clearTimeout(searchDebounce);
      searchDebounce = window.setTimeout(() => {
        fetchSearchSuggestions(event.target.value.trim());
      }, 180);
    });
  }

  if (mobileToggle && header) {
    mobileToggle.addEventListener('click', (event) => {
      event.preventDefault();
      const shouldOpen = !header.classList.contains('is-mobile-menu-open');

      header.classList.toggle('is-mobile-menu-open', shouldOpen);
      mobileToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

      if (!shouldOpen) {
        toggleSilverCategory(false);
        toggleMadeToOrderCategory(false);
        toggleChakraMenu(false);
        toggleForestCarvingsMenu(false);
        dropdownWraps.forEach((wrap) => {
          wrap.classList.remove('is-open');
          wrap.querySelector('.header__dropdown-trigger')?.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  dropdownWraps.forEach((wrap) => {
    const trigger = wrap.querySelector('.header__dropdown-trigger');

    if (!trigger) {
      return;
    }

    const closeDropdown = () => {
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      if (wrap === silverCategoryDropdown || wrap === madeToOrderCategoryDropdown) {
        toggleSilverCategory(false);
        toggleMadeToOrderCategory(false);
      }

      if (wrap === chakraMenuDropdown) {
        toggleChakraMenu(false);
      }

      if (wrap === forestCarvingsDropdown) {
        toggleForestCarvingsMenu(false);
      }
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const shouldOpen = !wrap.classList.contains('is-open');

      dropdownWraps.forEach((otherWrap) => {
        if (otherWrap !== wrap) {
          otherWrap.classList.remove('is-open');
          otherWrap.querySelector('.header__dropdown-trigger')?.setAttribute('aria-expanded', 'false');
        }
      });

      if (wrap !== chakraMenuDropdown) {
        toggleChakraMenu(false);
      }

      if (wrap !== forestCarvingsDropdown) {
        toggleForestCarvingsMenu(false);
      }

      wrap.classList.toggle('is-open', shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      fitDropdowns();
    });

    document.addEventListener('click', (event) => {
      if (!wrap.contains(event.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key == 'Escape') {
        closeDropdown();
        closeSearch();
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!header || !mobileToggle) {
      return;
    }

    if (!header.contains(event.target)) {
      header.classList.remove('is-mobile-menu-open');
      mobileToggle.setAttribute('aria-expanded', 'false');
      toggleSilverCategory(false);
      toggleMadeToOrderCategory(false);
      toggleChakraMenu(false);
      closeSearch();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024 && header && mobileToggle) {
      header.classList.remove('is-mobile-menu-open');
      header.classList.remove('is-mobile-nav-hidden');
      mobileToggle.setAttribute('aria-expanded', 'false');
    }

    updateHeader();
    fitDropdowns();
  });

  window.visualViewport?.addEventListener('resize', fitDropdowns);
  window.visualViewport?.addEventListener('scroll', fitDropdowns);
  document.fonts?.ready.then(fitDropdowns);

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrubSections = document.querySelectorAll('[data-video-scrub]');

    scrubSections.forEach((section) => {
      const video = section.querySelector('.scroll-video-space__video');

      if (!video) {
        return;
      }

      const mobilePlayback = window.matchMedia('(max-width: 860px)');

      if (mobilePlayback.matches) {
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;

        const startMobilePlayback = () => {
          const playAttempt = video.play();

          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {
              video.setAttribute('data-autoplay-blocked', 'true');
            });
          }
        };

        if (video.readyState >= 2) {
          startMobilePlayback();
        } else {
          video.addEventListener('canplay', startMobilePlayback, { once: true });
        }

        video.load();
        return;
      }

      let isTicking = false;
      let isReady = false;
      let wantedTime = 0;
      let pendingTime = 0;
      const seekThreshold = 0.08;

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const syncVideo = () => {
        if (!isReady || !Number.isFinite(video.duration) || video.duration <= 0) {
          return;
        }

        const endTime = Math.max(0, video.duration - 0.04);
        const nextTime = clamp(wantedTime, 0, endTime);
        pendingTime = nextTime;

        if (video.seeking) {
          return;
        }

        if (Math.abs(video.currentTime - nextTime) > seekThreshold) {
          video.currentTime = nextTime;
        }
      };

      const updateScrub = () => {
        const rect = section.getBoundingClientRect();
        const scrollDistance = Math.max(1, section.offsetHeight - window.innerHeight);
        const progress = clamp(-rect.top / scrollDistance, 0, 1);

        wantedTime = progress * (video.duration || 0);
        syncVideo();
        isTicking = false;
      };

      const requestScrub = () => {
        if (isTicking) {
          return;
        }

        isTicking = true;
        window.requestAnimationFrame(updateScrub);
      };

      const prepareVideo = () => {
        isReady = true;
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        video.pause();
        video.currentTime = 0;
        requestScrub();
      };

      video.addEventListener('loadedmetadata', prepareVideo, { once: true });
      video.addEventListener('canplay', () => {
        video.pause();
        syncVideo();
      });
      video.addEventListener('seeked', () => {
        if (Math.abs(video.currentTime - pendingTime) > seekThreshold) {
          syncVideo();
        }
      });

      window.addEventListener('scroll', requestScrub, { passive: true });
      window.addEventListener('resize', requestScrub);

      video.load();
      requestScrub();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroVideos = document.querySelectorAll('.hero__video');

    heroVideos.forEach((video) => {
      video.controls = false;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      const startVideo = () => {
        const playAttempt = video.play();

        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {
            video.setAttribute('data-autoplay-blocked', 'true');
          });
        }
      };

      if (video.readyState >= 2) {
        startVideo();
      } else {
        video.addEventListener('canplay', startVideo, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  const aboutLayouts = document.querySelectorAll('[data-about-layout]');

  aboutLayouts.forEach((layout) => {
    const copy = layout.querySelector('[data-about-copy]');
    const media = layout.querySelector('[data-about-media]');

    if (!copy || !media) {
      return;
    }

    const image = copy.querySelector('img');

    if (!image) {
      layout.classList.add('is-empty-media');
      return;
    }

    image.removeAttribute('style');
    image.setAttribute('loading', 'lazy');
    media.appendChild(image);
    media.removeAttribute('aria-hidden');
  });

  const aboutStories = document.querySelectorAll('.static-page__about-copy .about-story');

  aboutStories.forEach((story) => {
    const closingHeading = story.querySelector('.about-story__closing h2');

    if (closingHeading) {
      closingHeading.remove();
    }

    const chapters = story.querySelectorAll(':scope > .about-story__chapter');

    chapters.forEach((chapter) => {
      const heading = chapter.querySelector('.about-story__chapter-heading');
      const index = heading ? heading.querySelector('.about-story__chapter-index') : null;
      const headingText = heading ? heading.querySelector('h3') : null;
      const copy = chapter.querySelector('.about-story__chapter-copy');

      if (!index || !headingText || !copy) {
        return;
      }

      const details = document.createElement('details');
      details.className = 'about-story__accordion';

      const summary = document.createElement('summary');
      summary.className = 'about-story__accordion-summary';

      const summaryIndex = document.createElement('span');
      summaryIndex.className = 'about-story__chapter-index';
      summaryIndex.textContent = index.textContent.trim();

      const summaryTitle = document.createElement('span');
      summaryTitle.className = 'about-story__accordion-title';
      summaryTitle.setAttribute('role', 'heading');
      summaryTitle.setAttribute('aria-level', '3');
      summaryTitle.textContent = headingText.textContent.trim();

      summary.append(summaryIndex, summaryTitle);
      details.append(summary, copy);
      chapter.replaceWith(details);
    });
  });

  const whatsappForms = document.querySelectorAll('[data-contact-whatsapp-form]');

  whatsappForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const whatsappNumber = (form.dataset.whatsappNumber || '').replace(/\D/g, '');
      const status = form.querySelector('[data-contact-whatsapp-status]');

      if (!whatsappNumber) {
        if (status) {
          status.textContent = 'WhatsApp number is not configured.';
          status.hidden = false;
        }
        return;
      }

      const formData = new FormData(form);
      const message = [
        'New contact enquiry',
        '',
        `Name: ${formData.get('name') || ''}`,
        `Email: ${formData.get('email') || ''}`,
        `Subject: ${formData.get('subject') || ''}`,
        '',
        `Message: ${formData.get('message') || ''}`,
      ].join('\n');

      window.location.href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-recommendations]');
    const wireHoverVideos = (root) => {
      root.querySelectorAll('.product-recommendations__card').forEach((card) => {
        if (card.dataset.hoverVideoWired === 'true') return;

        const video = card.querySelector('.product-recommendations__hover-video');
        if (!video) return;

        card.dataset.hoverVideoWired = 'true';
        const play = () => {
          video.play()
            .then(() => { card.dataset.hoverVideoActive = 'true'; })
            .catch(() => { card.dataset.hoverVideoActive = 'false'; });
        };
        const stop = () => {
          card.dataset.hoverVideoActive = 'false';
          video.pause();
          video.currentTime = 0;
        };

        card.addEventListener('mouseenter', play);
        card.addEventListener('mouseleave', stop);
        card.addEventListener('focusin', play);
        card.addEventListener('focusout', stop);
      });
    };

    sections.forEach(wireHoverVideos);

    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-recommendations-previous], [data-recommendations-next]');
      if (!control) return;

      const carousel = control.closest('.product-recommendations__carousel');
      const track = carousel ? carousel.querySelector('[data-recommendations-track]') : null;
      if (!track) return;

      if (track.dataset.recommendationsScrolling === 'true') return;

      const cards = Array.from(track.querySelectorAll('.product-recommendations__card'));
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
      const step = 1;
      const currentIndex = Math.round(track.scrollLeft / (cardWidth + gap));
      const direction = control.hasAttribute('data-recommendations-next') ? 1 : -1;
      const targetIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + (direction * step)));

      track.dataset.recommendationsScrolling = 'true';
      track.scrollTo({ left: cards[targetIndex].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });

      window.setTimeout(() => {
        delete track.dataset.recommendationsScrolling;
      }, 450);
    });

    const loadRecommendations = (section) => {
      const url = section.dataset.url;

      if (!url || section.dataset.recommendationsLoaded === 'true') {
        return;
      }

      section.dataset.recommendationsLoaded = 'true';

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;
          const responseSection = container.querySelector('[data-product-recommendations]');

          if (responseSection) {
            section.innerHTML = responseSection.innerHTML;
            wireHoverVideos(section);
          }
        })
        .catch(() => {
          section.dataset.recommendationsLoaded = 'false';
        });
    };

    if (!('IntersectionObserver' in window)) {
      sections.forEach(loadRecommendations);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          loadRecommendations(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 200px 0px' });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const thumbs = document.querySelectorAll('.pdp__thumb');
  const mainMedia = document.querySelector('[data-product-main-media]');
  const mainMediaFrame = document.querySelector('[data-product-main-media-frame]');
  const zoomOpenButton = document.querySelector('[data-product-zoom-open]');
  const zoomOverlay = document.querySelector('[data-product-zoom]');
  const zoomCloseButton = document.querySelector('[data-product-zoom-close]');
  const zoomImage = document.querySelector('[data-product-zoom-image]');
  const hoverZoom = document.querySelector('[data-product-hover-zoom]');
  const quantityInput = document.querySelector('.pdp__qty-input');
  const minusButton = document.querySelector('[data-qty-minus]');
  const plusButton = document.querySelector('[data-qty-plus]');
  const variantSelect = document.querySelector('.pdp__variant-select');
  const productForm = document.querySelector('.pdp__form');
  const addToCartButton = document.querySelector('.pdp__atc');
  const buyNowWrapper = document.querySelector('[data-buy-now-wrapper]');
  const buyNowButton = document.querySelector('[data-buy-now-button]');
  const cartError = document.querySelector('[data-cart-error]');
  const currentPrice = document.querySelector('[data-product-current-price]');
  const comparePrice = document.querySelector('[data-product-compare-price]');
  const saleBadge = document.querySelector('[data-product-sale-badge]');
  const priceWrap = document.querySelector('[data-product-price]');
  const bulkNote = document.querySelector('[data-product-bulk-note]');
  const variantJson = document.querySelector('[data-product-variants]');
  const variantMediaJson = document.querySelector('[data-variant-media-map]');
  const productVideoMediaCodeJson = document.querySelector('[data-product-video-media-code-map]');
  const bulkSourceJson = document.querySelector('[data-product-bulk-source]');
  const bulkPricing = document.querySelector('[data-bulk-pricing]');
  const bulkPricingRows = document.querySelector('[data-bulk-pricing-rows]');
  const requestPhoneInput = document.querySelector('[data-request-phone]');
  const optionGroups = document.querySelectorAll('.pdp__variant-option');
    const priceVariantButtons = document.querySelectorAll('[data-price-variant-id], [data-price-option-index]');
  const selectedVariantCode = document.querySelector('[data-selected-variant-code]');
  const selectedVariantImageWrap = document.querySelector('[data-selected-variant-image-wrap]');
  const selectedVariantImage = document.querySelector('[data-selected-variant-image]');
  const variants = variantJson ? JSON.parse(variantJson.textContent) : [];
  const variantMediaMap = variantMediaJson ? JSON.parse(variantMediaJson.textContent) : {};
  const productVideoMediaCodeMap = productVideoMediaCodeJson ? JSON.parse(productVideoMediaCodeJson.textContent) : {};
  const bulkSource = bulkSourceJson ? JSON.parse(bulkSourceJson.textContent) : {};
  const isStatementPiece = productForm && productForm.dataset.statementPiece === 'true';
  const isMakeOnOrder = buyNowWrapper && buyNowWrapper.dataset.makeOnOrder === 'true';
  const makeOnOrderNote = buyNowWrapper ? buyNowWrapper.dataset.makeOnOrderNote : '';
  const shouldHideSquareBraceletOptions = productForm && productForm.dataset.squareBraceletOptions === 'true';
  const codeOptionIndex = productForm ? Number(productForm.dataset.codeOptionIndex || 0) - 1 : -1;
  const mediaMatchOptionIndex = productForm ? Number(productForm.dataset.mediaMatchOptionIndex || 0) - 1 : -1;
  const primaryMediaId = mainMedia ? mainMedia.dataset.productPrimaryMediaId : '';
  const hideGalleryVideos = mainMedia && mainMedia.dataset.hideGalleryVideos === 'true';
  let activeVariant = variants.find((variant) => variantSelect && String(variant.id) === variantSelect.value) || variants[0];

  const renderMakeOnOrderNote = () => {
    if (!isMakeOnOrder || !makeOnOrderNote || !buyNowWrapper || !productForm) {
      return;
    }

    if (productForm.querySelector('[data-make-on-order-notice]')) {
      return;
    }

    const notice = document.createElement('p');
    notice.className = 'pdp__made-on-order-note';
    notice.dataset.makeOnOrderNotice = 'true';
    notice.textContent = makeOnOrderNote;
    buyNowWrapper.parentNode.insertBefore(notice, buyNowWrapper);
  };

  renderMakeOnOrderNote();

  const getMainImage = () => document.getElementById('pdp-main-img');

  const normalizeRequestPhone = () => {
    if (!requestPhoneInput) {
      return;
    }

    const localDigits = requestPhoneInput.value.replace(/^\+91\s*/, '').replace(/\D/g, '').slice(0, 10);
    requestPhoneInput.value = `+91 ${localDigits}`;
  };

  if (requestPhoneInput) {
    normalizeRequestPhone();
    requestPhoneInput.addEventListener('input', normalizeRequestPhone);
    requestPhoneInput.addEventListener('focus', () => {
      if (requestPhoneInput.selectionStart < 4) {
        requestPhoneInput.setSelectionRange(requestPhoneInput.value.length, requestPhoneInput.value.length);
      }
    });
    requestPhoneInput.addEventListener('keydown', (event) => {
      if ((event.key === 'Backspace' || event.key === 'Delete') && requestPhoneInput.selectionStart <= 4) {
        event.preventDefault();
      }
    });
  }

  const muteProductVideos = () => {
    document.querySelectorAll('.pdp video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.controls = false;
      video.autoplay = true;
      video.loop = true;
      video.removeAttribute('controls');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      video.disablePictureInPicture = true;

      if (video.dataset.muteLockBound === 'true') {
        return;
      }

      video.dataset.muteLockBound = 'true';
      video.addEventListener('volumechange', () => {
        if (!video.muted || video.volume !== 0) {
          video.muted = true;
          video.volume = 0;
        }
      });
    });
  };

  const formatInr = (price) => {
    const amount = Number(price || 0) / 100;
    const formatted = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    return `Rs. ${formatted}`;
  };

  const getBulkDiscountPercent = (quantity) => {
    if (quantity >= 20) {
      return 60;
    }

    if (quantity >= 10) {
      return 55;
    }

    if (quantity >= 5) {
      return 45;
    }

    return 0;
  };

  const normalizeQuantity = (quantity) => {
    const normalizedQuantity = Math.max(1, Number(quantity || 1));
    return isStatementPiece ? 1 : normalizedQuantity;
  };

  const setQuantity = (quantity) => {
    if (!quantityInput) {
      return;
    }

    quantityInput.value = normalizeQuantity(quantity);

    if (isStatementPiece) {
      quantityInput.max = '1';
      quantityInput.readOnly = true;

      if (minusButton) {
        minusButton.disabled = true;
        minusButton.setAttribute('aria-disabled', 'true');
      }

      if (plusButton) {
        plusButton.disabled = true;
        plusButton.setAttribute('aria-disabled', 'true');
      }
    }
  };

  const getQuantity = () => normalizeQuantity(quantityInput ? quantityInput.value || 1 : 1);

  const getDiscountedLinePrice = (unitPrice, quantity, discountPercent) => {
    const linePrice = Number(unitPrice || 0) * quantity;
    return Math.round(linePrice * (100 - discountPercent) / 100);
  };

  const parseExactBulkOffers = () => {
    const description = String(bulkSource.description || '').replace(/\s+/g, ' ').trim();
    const offers = [];
    const labeledBulkPattern = /\(?\s*([^()\n\r]*?)\s*Bulk\s+(\d+)\s+pieces?\s*\)?\s*[:\-]?\s*(?:Rs\.?\s*)?([\d,]+(?:\.\d+)?)\s*rs?/gi;
    const packPattern = /Pack\s+of\s+(\d+)\s+pieces?.*?Rs\.?\s*([\d,]+(?:\.\d+)?)/gi;
    let match = labeledBulkPattern.exec(description);

    while (match) {
      const label = String(match[1] || '').replace(/[:\-]+$/g, '').trim();
      const pieces = String(match[2]).trim();
      const price = Number(String(match[3]).replace(/,/g, ''));

      offers.push({
        quantity: label ? `${label} / ${pieces} pieces` : `${pieces} pieces`,
        offer: formatInr(price * 100),
      });
      match = labeledBulkPattern.exec(description);
    }

    match = packPattern.exec(description);

    while (match) {
      const price = Number(String(match[2]).replace(/,/g, ''));
      offers.push({
        quantity: `${match[1]} pieces`,
        offer: formatInr(price * 100),
      });
      match = packPattern.exec(description);
    }

    return offers;
  };

  const parseVariantBulkOffers = () => {
    const offers = [];
    const seenOffers = new Set();

    variants.forEach((variant) => {
      const optionValues = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];

      optionValues.forEach((optionValue) => {
        const value = String(optionValue || '').trim();
        const match = value.match(/^(.*?)(?:\s*[—–-]\s*)?(?:bulk\s+|pack\s+of\s+)(\d+)\s+pieces?\b/i);

        if (!match) {
          return;
        }

        const optionLabel = String(match[1] || '').replace(/[\s—–-]+$/g, '').trim();
        const pieces = String(match[2]).trim();
        const quantity = optionLabel ? `${optionLabel} / ${pieces} pieces` : `${pieces} pieces`;
        const offer = formatInr(Number(variant.price || 0));
        const key = `${quantity}|${offer}`;

        if (!seenOffers.has(key)) {
          seenOffers.add(key);
          offers.push({ quantity, offer });
        }
      });
    });

    return offers;
  };

  const getBulkPricingRows = (variant) => {
    const variantOffers = parseVariantBulkOffers();

    if (variantOffers.length > 0) {
      return variantOffers;
    }

    const exactOffers = parseExactBulkOffers();

    if (exactOffers.length > 0) {
      return exactOffers;
    }

    if (!bulkSource.isBracelet || !variant) {
      return [];
    }

    return [
      { quantity: '5 pieces', offer: formatInr(getDiscountedLinePrice(variant.price, 5, 45)) },
      { quantity: '10 pieces', offer: formatInr(getDiscountedLinePrice(variant.price, 10, 55)) },
      { quantity: '20 pieces', offer: formatInr(getDiscountedLinePrice(variant.price, 20, 60)) },
    ];
  };

  const updateBulkPricingTable = (variant) => {
    if (!bulkPricing || !bulkPricingRows) {
      return;
    }

    const rows = getBulkPricingRows(variant);

    if (rows.length === 0) {
      bulkPricing.hidden = true;
      bulkPricingRows.innerHTML = '';
      return;
    }

    bulkPricingRows.innerHTML = rows.map((row) => (
      `<tr><td>${row.quantity}</td><td>${row.offer}</td></tr>`
    )).join('');
    bulkPricing.hidden = false;
  };

  const updatePrice = (variant) => {
    if (!variant || !currentPrice) {
      return;
    }

    activeVariant = variant;
    updateBulkPricingTable(variant);

    const quantity = getQuantity();
    const isBulkBracelet = priceWrap && priceWrap.dataset.bulkBracelet === 'true';
    const discountPercent = isBulkBracelet ? getBulkDiscountPercent(quantity) : 0;

    if (discountPercent > 0) {
      const originalLinePrice = Number(variant.price || 0) * quantity;
      const discountedLinePrice = getDiscountedLinePrice(variant.price, quantity, discountPercent);

      currentPrice.textContent = formatInr(discountedLinePrice);
      currentPrice.classList.add('pdp__price--sale');

      if (comparePrice) {
        comparePrice.textContent = formatInr(originalLinePrice);
        comparePrice.hidden = false;
      }

      if (saleBadge) {
        saleBadge.hidden = false;
      }

      if (bulkNote) {
        const prefix = priceWrap ? priceWrap.dataset.bulkNotePrefix : '';
        const suffix = priceWrap ? priceWrap.dataset.bulkNoteSuffix : '';
        bulkNote.textContent = `${discountPercent}% ${prefix} ${quantity} ${suffix}`.trim();
        bulkNote.hidden = false;
      }

      return;
    }

    const linePrice = Number(variant.price || 0) * quantity;
    currentPrice.textContent = formatInr(linePrice);

    const hasComparePrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    currentPrice.classList.toggle('pdp__price--sale', hasComparePrice);

    if (comparePrice) {
      comparePrice.textContent = hasComparePrice ? formatInr(Number(variant.compare_at_price || 0) * quantity) : '';
      comparePrice.hidden = !hasComparePrice;
    }

    if (saleBadge) {
      saleBadge.hidden = !hasComparePrice;
    }

    if (bulkNote) {
      bulkNote.hidden = true;
      bulkNote.textContent = '';
    }
  };

  const syncPurchaseControls = (variant) => {
    const isAvailable = Boolean(variant && variant.available);

    if (addToCartButton) {
      addToCartButton.disabled = !isAvailable;
      addToCartButton.classList.toggle('pdp__atc--sold-out', !isAvailable);
      addToCartButton.textContent = isAvailable
        ? addToCartButton.dataset.addToCartText
        : addToCartButton.dataset.soldOutText;
    }

    if (buyNowWrapper) {
      buyNowWrapper.classList.toggle('is-sold-out', !isAvailable);
      buyNowWrapper.toggleAttribute('inert', !isAvailable);

      if (isAvailable) {
        buyNowWrapper.removeAttribute('aria-disabled');
      } else {
        buyNowWrapper.setAttribute('aria-disabled', 'true');
      }

      buyNowWrapper.querySelectorAll('button, [role="button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart').forEach((control) => {
        control.toggleAttribute('disabled', !isAvailable);
        control.setAttribute('aria-disabled', String(!isAvailable));
      });
    }
  };

  const getVariantCode = (variant) => {
    if (!variant || codeOptionIndex < 0) {
      return '';
    }

    return variant.options[codeOptionIndex] || '';
  };

  const getVariantMediaKey = (variant) => {
    if (!variant || mediaMatchOptionIndex < 0) {
      return '';
    }

    return variant.options[mediaMatchOptionIndex] || '';
  };

  const syncNativeOptions = (variant) => {
    if (!variant) {
      return;
    }

    optionGroups.forEach((optionGroup, index) => {
      const optionValue = variant.options[index];
      const selectedInput = Array.from(optionGroup.querySelectorAll('input[type="radio"]')).find((input) => {
        return input.value === optionValue;
      });

      if (selectedInput) {
        selectedInput.checked = true;
      }
    });
  };

  const getOptionGroupName = (optionGroup) => {
    if (optionGroup.dataset.optionName) {
      return optionGroup.dataset.optionName;
    }

    const label = optionGroup.querySelector('.pdp__label');
    return label ? label.textContent.trim().toLowerCase().replace(/\s+/g, '-') : '';
  };

  const getShapeOptionIndex = () => Array.from(optionGroups).findIndex((optionGroup) => {
    return getOptionGroupName(optionGroup) === 'shape';
  });

  const getSelectedOptions = () => Array.from(optionGroups).map((optionGroup) => {
    const selected = optionGroup.querySelector('input[type="radio"]:checked');
    return selected ? selected.value : '';
  });

  const findVariantFromOptions = (selectedOptions) => {
    const exactVariant = variants.find((variant) => {
      return selectedOptions.every((value, index) => variant.options[index] === value);
    });

    if (exactVariant) {
      return exactVariant;
    }

    if (!shouldHideSquareBraceletOptions) {
      return null;
    }

    const shapeIndex = getShapeOptionIndex();

    if (shapeIndex < 0 || String(selectedOptions[shapeIndex] || '').toLowerCase() !== 'square') {
      return null;
    }

    return variants.find((variant) => {
      return String(variant.options[shapeIndex] || '').toLowerCase() === 'square';
    }) || null;
  };

  const findClosestAvailableVariant = (selectedOptions, changedOptionIndex) => {
    const compatibleVariants = variants.filter((variant) => {
      return variant.available && variant.options[changedOptionIndex] === selectedOptions[changedOptionIndex];
    });

    if (compatibleVariants.length === 0) {
      return null;
    }

    return compatibleVariants.reduce((closestVariant, candidate) => {
      const getMatchScore = (variant) => variant.options.reduce((score, value, index) => {
        if (index === changedOptionIndex) {
          return score;
        }

        return score + (value === selectedOptions[index] ? 1 : 0);
      }, 0);

      return getMatchScore(candidate) > getMatchScore(closestVariant) ? candidate : closestVariant;
    });
  };

  const findVariantForPriceChoice = (optionIndex, optionValue) => {
    if (!activeVariant || Number.isNaN(optionIndex)) {
      return null;
    }

    const selectedOptions = [...activeVariant.options];
    selectedOptions[optionIndex] = optionValue;

    const matchingVariant = variants.find((variant) => {
      if (!variant.available || variant.options[optionIndex] !== optionValue) {
        return false;
      }

      return variant.options.every((value, index) => {
        if (index === optionIndex || index === codeOptionIndex) {
          return true;
        }

        return value === selectedOptions[index];
      });
    });

    if (matchingVariant) {
      return matchingVariant;
    }

    return variants.find((variant) => variant.available && variant.options[optionIndex] === optionValue) || null;
  };

  const syncOptionAvailability = (variant) => {
    if (!variant || !variant.options) {
      return;
    }

    optionGroups.forEach((optionGroup, optionIndex) => {
      const radioInputs = optionGroup.querySelectorAll('input[type="radio"]');
      const isPurchaseTypeOption = getOptionGroupName(optionGroup) === 'purchase-type';

      radioInputs.forEach((input) => {
        const candidateOptions = [...variant.options];
        candidateOptions[optionIndex] = input.value;
        const isAvailable = variants.some((candidate) => {
          if (isPurchaseTypeOption) {
            return candidate.available && candidate.options[optionIndex] === input.value;
          }

          return candidate.available && candidate.options.every((value, index) => value === candidateOptions[index]);
        });

        input.disabled = !isAvailable;
        const label = optionGroup.querySelector(`label[for="${input.id}"]`);

        if (label) {
          label.setAttribute('aria-disabled', String(!isAvailable));
        }
      });
    });
  };

  const syncSquareBraceletOptions = (variant) => {
    if (!shouldHideSquareBraceletOptions || optionGroups.length === 0) {
      return;
    }

    const shapeIndex = getShapeOptionIndex();

    if (shapeIndex < 0) {
      return;
    }

    const selectedOptions = variant && variant.options ? variant.options : getSelectedOptions();
    const isSquareShape = String(selectedOptions[shapeIndex] || '').trim().toLowerCase() === 'square';

    optionGroups.forEach((optionGroup) => {
      const optionName = getOptionGroupName(optionGroup);
      const shouldHide = isSquareShape && (optionName === 'bead-size' || optionName === 'size');

      optionGroup.hidden = shouldHide;
      optionGroup.setAttribute('aria-hidden', String(shouldHide));
    });
  };

  const syncPriceButtons = (variant) => {
    priceVariantButtons.forEach((button) => {
      const optionIndex = Number(button.dataset.priceOptionIndex);
      const optionValue = button.dataset.priceOptionValue;
      const isOptionValueButton = !Number.isNaN(optionIndex) && Boolean(optionValue);
      const isActive = isOptionValueButton
        ? Boolean(variant && variant.options[optionIndex] === optionValue)
        : Boolean(variant && button.dataset.priceVariantId === String(variant.id));
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));

      if (isOptionValueButton) {
        const isAvailable = variants.some((candidate) => {
          return candidate.available && candidate.options[optionIndex] === optionValue;
        });
        button.disabled = !isAvailable;
      }
    });
  };

  const updateSelectedVariantSummary = (variant) => {
    if (selectedVariantCode) {
      selectedVariantCode.textContent = getVariantCode(variant);
    }

    if (!selectedVariantImage || !selectedVariantImageWrap) {
      return;
    }

    const variantMedia = variant ? variantMediaMap[String(variant.id)] : null;
    const activeImage = getMainImage();
    const fallbackSrc = activeImage ? activeImage.currentSrc || activeImage.src : '';

    if (!variantMedia || !variantMedia.src) {
      if (fallbackSrc) {
        selectedVariantImage.src = fallbackSrc;
        selectedVariantImage.removeAttribute('srcset');
        selectedVariantImageWrap.hidden = false;
        return;
      }

      selectedVariantImageWrap.hidden = true;
      return;
    }

    selectedVariantImage.src = variantMedia.src;
    selectedVariantImage.removeAttribute('srcset');

    if (variantMedia.alt) {
      selectedVariantImage.alt = variantMedia.alt;
    }

    selectedVariantImageWrap.hidden = false;
  };

  const applyVariant = (variant, selectedOptions) => {
    if (!variant) {
      return;
    }

    activeVariant = variant;

    if (variantSelect) {
      variantSelect.value = variant.id;
    }

    syncNativeOptions(variant);
    syncSquareBraceletOptions(variant);
    syncOptionAvailability(variant);
    syncPriceButtons(variant);
    updatePrice(variant);
    syncPurchaseControls(variant);
    updateSelectedVariantSummary(variant);
    updateMediaForVariant(variant, selectedOptions || variant.options || []);
  };

  const normalizeMediaUrl = (src) => {
    return src ? src.split('?')[0] : '';
  };

  const setActiveThumb = (matchingThumb) => {
    thumbs.forEach((thumb) => thumb.classList.remove('is-active'));

    if (matchingThumb) {
      matchingThumb.classList.add('is-active');
    }
  };

  const findThumbBySrc = (src) => {
    const normalizedSrc = normalizeMediaUrl(src);

    return Array.from(thumbs).find((thumb) => {
      return normalizeMediaUrl(thumb.dataset.src) === normalizedSrc;
    });
  };

  const findThumbByMediaId = (mediaId) => {
    return Array.from(thumbs).find((thumb) => thumb.dataset.mediaId === String(mediaId));
  };

  const findVariantVideoMediaId = (variant) => {
    const variantMediaKey = getVariantMediaKey(variant);
    const mappedMedia = variantMediaKey ? productVideoMediaCodeMap[variantMediaKey] : null;

    if (!mappedMedia || !mappedMedia.mediaId) {
      return null;
    }

    return String(mappedMedia.mediaId);
  };

  const findVariantForVideoThumb = (thumb) => {
    if (!thumb || !thumb.dataset.mediaId) {
      return null;
    }

    const mediaId = String(thumb.dataset.mediaId);

    return variants.find((variant) => {
      const variantMediaKey = getVariantMediaKey(variant);
      const mappedMedia = variantMediaKey ? productVideoMediaCodeMap[variantMediaKey] : null;

      return mappedMedia && String(mappedMedia.mediaId) === mediaId;
    }) || null;
  };

  const syncImageZoomTargets = (src, alt) => {
    if (!src) {
      return;
    }

    if (hoverZoom) {
      hoverZoom.style.backgroundImage = `url("${src}")`;
    }

    if (zoomImage) {
      zoomImage.removeAttribute('srcset');
      zoomImage.src = src;

      if (alt) {
        zoomImage.alt = alt;
      }
    }
  };

  const updateMainImage = (src, alt) => {
    if (!mainMediaFrame || !src) {
      return;
    }

    const currentImg = getMainImage();

    if (currentImg) {
      currentImg.removeAttribute('srcset');
      currentImg.src = src;

      if (alt) {
        currentImg.alt = alt;
      }
    } else {
      mainMediaFrame.innerHTML = `<img id="pdp-main-img" src="${src}" alt="${alt || ''}">`;
    }

    if (mainMedia) {
      mainMedia.classList.remove('pdp__main-image--video');
    }

    if (zoomOpenButton) {
      zoomOpenButton.hidden = false;
    }

    syncImageZoomTargets(src, alt);
  };

  const updateMainMediaFromMediaId = (mediaId) => {
    if (!mediaId || !mainMediaFrame) {
      return;
    }

    const template = document.querySelector(`[data-product-media-template="${mediaId}"]`);

    if (!template) {
      return;
    }

    mainMediaFrame.innerHTML = template.innerHTML;
    muteProductVideos();

    if (mainMedia) {
      mainMedia.classList.add('pdp__main-image--video');
    }

    if (zoomOpenButton) {
      zoomOpenButton.hidden = true;
    }
  };

  const updateMainMediaFromThumb = (thumb) => {
    if (!thumb || !mainMediaFrame) {
      return;
    }

    const mediaType = thumb.dataset.mediaType || 'image';

    if (mediaType === 'image') {
      updateMainImage(thumb.dataset.src, thumb.dataset.alt);
      return;
    }

    updateMainMediaFromMediaId(thumb.dataset.mediaId);
  };

  const updateMediaForVariant = (variant, selectedOptions) => {
    if (!mainMediaFrame) {
      return;
    }

    const variantMedia = variant ? variantMediaMap[String(variant.id)] : null;
    const matchingVideoMediaId = findVariantVideoMediaId(variant);

    if (hideGalleryVideos && matchingVideoMediaId) {
      updateMainMediaFromMediaId(matchingVideoMediaId);
      setActiveThumb(null);
      return;
    }

    if (variantMedia && variantMedia.src) {
      if (hideGalleryVideos && variantMedia.mediaType === 'video') {
        updateMainMediaFromMediaId(variantMedia.mediaId);
        setActiveThumb(null);
        return;
      }

      const matchingThumb = findThumbBySrc(variantMedia.src);

      updateMainImage(variantMedia.src, variantMedia.alt);
      setActiveThumb(matchingThumb);
      return;
    }

    if (matchingVideoMediaId) {
      updateMainMediaFromMediaId(matchingVideoMediaId);
      setActiveThumb(findThumbByMediaId(matchingVideoMediaId));
      return;
    }

    if (mediaMatchOptionIndex >= 0) {
      // Never keep the previous variant's video when this variant has no match.
      const primaryThumb = Array.from(thumbs).find((thumb) => thumb.dataset.mediaType === 'image');

      if (primaryThumb) {
        updateMainMediaFromThumb(primaryThumb);
        setActiveThumb(primaryThumb);
      } else {
        mainMediaFrame.replaceChildren();
        setActiveThumb(null);
        mainMedia?.classList.remove('pdp__main-image--video');
        if (zoomOpenButton) zoomOpenButton.hidden = true;
      }

      return;
    }

    const shapeIndex = Array.from(optionGroups).findIndex((optionGroup) => {
      const label = optionGroup.querySelector('.pdp__label');
      return label && label.textContent.trim().toLowerCase() === 'shape';
    });

    if (shapeIndex === -1) {
      return;
    }

    const shape = selectedOptions[shapeIndex] ? selectedOptions[shapeIndex].toLowerCase() : '';
    const matchingThumb = Array.from(thumbs).find((thumb) => thumb.dataset.shape === shape);

    if (!matchingThumb) {
      return;
    }

    updateMainImage(matchingThumb.dataset.src, matchingThumb.dataset.alt);
    setActiveThumb(matchingThumb);
  };

  if (mainMediaFrame) {
    const mainImg = getMainImage();

    if (hoverZoom) {
      hoverZoom.style.backgroundImage = mainImg ? `url("${mainImg.currentSrc || mainImg.src}")` : '';
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const matchingVariant = findVariantForVideoThumb(btn);

        if (matchingVariant) {
          applyVariant(matchingVariant);
          return;
        }

        updateMainMediaFromThumb(btn);
        setActiveThumb(btn);
      });
    });
  }

  if (zoomOpenButton && zoomOverlay && zoomCloseButton) {
    const closeZoom = () => {
      zoomOverlay.classList.remove('is-open');
      zoomOverlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    zoomOpenButton.addEventListener('click', () => {
      const mainImg = getMainImage();

      if (mainImg && zoomImage) {
        zoomImage.src = mainImg.currentSrc || mainImg.src;
      }
      zoomOverlay.classList.add('is-open');
      zoomOverlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    });

    zoomCloseButton.addEventListener('click', closeZoom);

    zoomOverlay.addEventListener('click', (event) => {
      if (event.target === zoomOverlay) {
        closeZoom();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && zoomOverlay.classList.contains('is-open')) {
        closeZoom();
      }
    });
  }

  if (quantityInput && minusButton && plusButton) {
    setQuantity(quantityInput.value || 1);

    minusButton.addEventListener('click', () => {
      setQuantity(Number(quantityInput.value || 1) - 1);
      updatePrice(activeVariant);
    });

    plusButton.addEventListener('click', () => {
      setQuantity(Number(quantityInput.value || 1) + 1);
      updatePrice(activeVariant);
    });

    quantityInput.addEventListener('input', () => {
      setQuantity(quantityInput.value || 1);
      updatePrice(activeVariant);
    });
  }

  if (variantSelect && variants.length > 0) {
    optionGroups.forEach((group) => {
      group.addEventListener('change', () => {
        const selectedOptions = getSelectedOptions();
        const optionIndex = Number(group.dataset.optionIndex);
        let selectedVariant = findVariantFromOptions(selectedOptions);

        if (!selectedVariant && getOptionGroupName(group) === 'purchase-type') {
          selectedVariant = findClosestAvailableVariant(selectedOptions, optionIndex);
        }

        if (selectedVariant) {
          applyVariant(selectedVariant, selectedOptions);
        }
      });
    });

    priceVariantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const optionIndex = Number(button.dataset.priceOptionIndex);
        const selectedVariant = !Number.isNaN(optionIndex) && button.dataset.priceOptionValue
          ? findVariantForPriceChoice(optionIndex, button.dataset.priceOptionValue)
          : variants.find((variant) => String(variant.id) === button.dataset.priceVariantId);
        applyVariant(selectedVariant);
      });
    });
  }

  applyVariant(activeVariant);
  muteProductVideos();

  if (buyNowWrapper) {
    buyNowWrapper.addEventListener('click', (event) => {
      if (buyNowWrapper.classList.contains('is-sold-out')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  if (buyNowButton && productForm && variantSelect && quantityInput) {
    buyNowButton.addEventListener('click', async () => {
      if (!activeVariant || !activeVariant.available) {
        return;
      }

      buyNowButton.disabled = true;
      buyNowButton.setAttribute('aria-busy', 'true');
      if (cartError) {
        cartError.hidden = true;
      }

      try {
        const selectedVariantId = String(variantSelect.value);
        const selectedQuantity = normalizeQuantity(quantityInput.value || 1);
        const cartResponse = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        });

        if (!cartResponse.ok) {
          throw new Error('Cart lookup failed');
        }

        const cart = await cartResponse.json();
        const existingLine = cart.items.find((item) => String(item.variant_id) === selectedVariantId);
        const response = await fetch(existingLine ? '/cart/change.js' : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: existingLine
            ? JSON.stringify({ id: existingLine.key, quantity: selectedQuantity })
            : JSON.stringify({ id: Number(selectedVariantId), quantity: selectedQuantity })
        });

        if (!response.ok) {
          throw new Error('Cart update failed');
        }

        window.location.assign('/checkout');
      } catch (error) {
        buyNowButton.disabled = false;
        buyNowButton.removeAttribute('aria-busy');
        if (cartError) {
          cartError.hidden = false;
        }
      }
    });
  }

  if (productForm && addToCartButton && variantSelect && quantityInput) {
    productForm.addEventListener('submit', async (event) => {
      if (event.submitter !== addToCartButton) {
        return;
      }

      event.preventDefault();

      const selectedVariantId = variantSelect.value;
      const quantity = normalizeQuantity(quantityInput.value || 1);

      addToCartButton.disabled = true;
      addToCartButton.setAttribute('aria-busy', 'true');
      if (cartError) {
        cartError.hidden = true;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: Number(selectedVariantId),
            quantity
          })
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        window.location.href = productForm.dataset.cartUrl || '/cart';
      } catch (error) {
        addToCartButton.disabled = false;
        addToCartButton.removeAttribute('aria-busy');
        if (cartError) {
          cartError.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const wireSearchCardHoverVideos = (root) => {
    root.querySelectorAll('.search-card').forEach((card) => {
      if (card.dataset.hoverVideoWired === 'true') return;

      const video = card.querySelector('.search-card__hover-video');
      if (!video) return;

      card.dataset.hoverVideoWired = 'true';
      const play = () => {
        video.play()
          .then(() => { card.dataset.hoverVideoActive = 'true'; })
          .catch(() => { card.dataset.hoverVideoActive = 'false'; });
      };
      const stop = () => {
        card.dataset.hoverVideoActive = 'false';
        video.pause();
        video.currentTime = 0;
      };

      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', play);
      card.addEventListener('focusout', stop);
    });
  };

  wireSearchCardHoverVideos(document);

  const searchResultFilters = document.querySelectorAll('[data-search-result-filter]');

  searchResultFilters.forEach((filter) => {
    const rawSearchTerms = (filter.dataset.searchTerms || '').trim();
    const collectionLabel = new URLSearchParams(window.location.search).get('collection_label');
    const isStructuredSearch = /(?:^|\s)(?:tag|vendor|product_type|type):/i.test(rawSearchTerms)
      || /\b(?:AND|OR|NOT)\b/i.test(rawSearchTerms);

    if (collectionLabel) {
      const collectionInputs = document.querySelectorAll('.search-page__input');
      const count = filter.querySelector('[data-search-result-count]');

      collectionInputs.forEach((input) => {
        let hasEditedSearch = false;

        input.value = collectionLabel;
        input.addEventListener('input', () => {
          hasEditedSearch = true;
        });
        input.form?.addEventListener('submit', () => {
          if (!hasEditedSearch) input.value = rawSearchTerms;
        });
      });

      if (count) {
        const resultCount = Number(filter.dataset.searchTotalCount || 0);
        count.textContent = `${resultCount} ${resultCount === 1 ? 'result' : 'results'} found for ${collectionLabel}`;
      }
    }

    if (isStructuredSearch) return;

    const queryTerms = rawSearchTerms
      .toLocaleLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    if (queryTerms.length === 0) return;

    const cards = Array.from(filter.querySelectorAll('[data-search-result]'));
    const count = filter.querySelector('[data-search-result-count]');
    const emptyState = filter.querySelector('[data-search-no-results]');
    const pagination = document.querySelector('.search-page__pagination');
    let visibleCount = 0;

    cards.forEach((card) => {
      const searchableText = (card.dataset.searchText || '').toLocaleLowerCase();
      const matches = queryTerms.every((term) => searchableText.includes(term));

      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (count) {
      count.textContent = `${visibleCount} ${visibleCount === 1 ? 'result' : 'results'} found for ${rawSearchTerms}`;
      count.hidden = visibleCount === 0;
    }

    if (emptyState) emptyState.hidden = visibleCount !== 0;

    if (pagination && visibleCount < cards.length) {
      pagination.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
